import { GridColumnConfig } from "../../../models/gridCoumnConfig";

export const scheduleColumns: GridColumnConfig[] = [
  {
    title: 'Work Order Number',
    field: 'workOrderNumber',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Service Code',
    field: 'serviceCode',
    filter: 'text',
    searchable: true,
  },
  {
    title: 'Scheduled Date',
    field: 'scheduledDate',
    filter: 'text',
  }
];
